import { post } from 'aws-amplify/api';

const API_BASE_URL = 'billivoRegister';

const getAuthHeaders = async () => {
  return {
    'x-api-key': process.env.REACT_APP_API_GATEWAY_KEY as string,
    'Content-Type': 'application/json',
  };
};

type SimpleFormPayload = {
  country: string;
  userType: 'Person' | 'Company';
  mailAddress: string;
  companyName: string;
  firstName: string;
  lastName: string;
  nationalId: string;
  vatId: string;
};

type SimpleFormResponse = {
  companyId: string;
  companyName?: string;
  temporaryPassword?: string;
  message?: string;
  error?: string;
  statusCode?: number;
};

export const registerSimpleForm = async (
  payload: SimpleFormPayload,
  captchaToken: string,
): Promise<SimpleFormResponse> => {
  try {
    const headers = await getAuthHeaders();

    const simpleFormResponse = await post({
      apiName: API_BASE_URL,
      path: '/simpleForm',
      options: {
        headers,
        body: {
          ...payload,
          token: captchaToken,
        },
      },
    });

    const responseBody = await (await simpleFormResponse.response).body;
    const responseJson = await responseBody.json();

    if (
      responseJson &&
      typeof responseJson === 'object' &&
      'statusCode' in responseJson &&
      responseJson.statusCode !== 200 &&
      responseJson.statusCode !== 201
    ) {
      throw new Error(
        (responseJson as any).error ||
          (responseJson as any).message ||
          'Error al registrar usuario',
      );
    }

    if (
      responseJson &&
      typeof responseJson === 'object' &&
      'error' in responseJson &&
      (responseJson as any).error
    ) {
      throw new Error((responseJson as any).error);
    }

    return responseJson as SimpleFormResponse;
  } catch (error) {
    console.error('Error registering simple form:', error);
    throw error;
  }
};
